import axios, { AxiosResponse } from 'axios'
import { env } from '@js/utils/env'

import gql from '@js/api/utils/gql'
import getStoreName from '@js/api/utils/getStoreName'
import getBearerToken from '@js/api/utils/getBearerToken'

export interface StoreCreditResponse {
  data: {
    customer: {
      store_credit: {
        current_balance: {
          currency: string
          value: number
        } | null
      } | null
    } | null
  }
  errors?: [{ message: string }]
}

export const storeCreditQuery = gql`
  query getCustomerStoreCredit {
    customer {
      store_credit {
        current_balance {
          currency
          value
        }
      }
    }
  }
`

export const getStoreCredit = async (): Promise<number> => {
  const bearerToken = getBearerToken()

  const { data }: AxiosResponse<StoreCreditResponse> = await axios({
    method: 'POST',
    url: env.magento.GRAPHQL_URL,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
      Store: getStoreName()
    },
    data: {
      query: storeCreditQuery,
    },
  })

  if (data.errors) {
    throw data.errors[0].message
  }

  const credit = data?.data?.customer?.store_credit?.current_balance?.value

  return credit ?? 0
}
